import script from "./OsExecutadasTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OsExecutadasTabPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__